$(document).ready((e) => {
    $('.collection--wrapper').removeClass('events-disabled')

    // Quick View script
    $(document).on('click', '.product---quick-view', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
    
        if (window.loadingQuickView) { return; }
          
        let product_url = $(e.target).attr('data-product-href');
        window.loadingQuickView = true;
    
        $.ajax({
            url: `${product_url}?view=ss-quick-view`,
            type: "GET",
            success: function (html) {
                window.loadingQuickView = false;
                $('.ss__quick-modal-content').html(html);
                $('.ss__quick-modal').addClass('active');
                window.events.trigger("pjax:load");
            },
            error: function(jqXHR, textStatus, errorThrown) {
                window.loadingQuickView = false;
                console.log("Quick View Error:", textStatus, errorThrown, jqXHR.responseText);
            }
        });
    });

    // Sort dropdown script
    $(document).on('click', 'button.collection--sort-btn', (e) => {
        e.preventDefault();
        let status = $('.collection--sort').attr('data-sort-dropdown');
    
        if( status ==  'true'  ) {
            $('.collection--sort').attr('data-sort-dropdown', 'false');
        } else {
            $('.collection--sort').attr('data-sort-dropdown', 'true');
        }
    })

    $(document).on('click', (e) => {
        let sortDropdown = $('.collection--toolbar .collection--sort').attr('data-sort-dropdown');

        if( sortDropdown == 'true' && $(e.target).closest('.products--grid.sort--dropdown').length == 0 && $(e.target).closest('.collection--sort-btn').length == 0 ) {
            $('.collection--toolbar .collection--sort').attr('data-sort-dropdown', false);
        }
    });

    // Products sort script
    $(document).on('click', '.sort--dropdown-option', (e) => {
        let pageUrl = $('#page-url').val();
        let sortValue = $(e.target).attr('data-sort-value');
        let sortLabel = $(e.target).attr('data-sort-label');
        let params = new URLSearchParams(window.location.search);

        $('.sort--dropdown-option').removeClass('active');
        $(`.sort--dropdown-option[data-sort-value="${ sortValue }"]`).addClass('active');
    
        params.delete('page');
        params.set('sort_by', sortValue);

        let requestURL = `${ pageUrl }?${ params.toString() }`;

        updateProductGrid(requestURL);
        
        $('.collection--sort-btn-label').text(sortLabel);
        $('.collection--sort').attr('data-sort-dropdown', 'false');
    })

    // Apply filter script
    // $(document).on('submit', '#products-filters-form-desktop', function(evt) {
    //     evt.preventDefault();
    //     applyProductFilter('#products-filters-form-desktop');
    // });
    $(document).on('change', '#products-filters-form-desktop .ff--option-input', function(evt) {
        evt.preventDefault();
        applyProductFilter('#products-filters-form-desktop');
    });

    // Apply mobile filter script
    // $(document).on('submit', '#products-filters-form-mobile', function(evt) {
    //     evt.preventDefault();
    //     applyProductFilter('#products-filters-form-mobile');
    // });
    $(document).on('change', '#products-filters-form-mobile .ff--option-input', function(evt) {
        evt.preventDefault();
        applyProductFilter('#products-filters-form-mobile');
    });

    // Clear All filter script
    $(document).on('click', '.clearall--button', function(evt) {
        evt.preventDefault();

        $('.ff--option-input').prop('checked', false);
        $('.ff--options-item').attr('data-filter-active', false);
        $('.clearall--button').addClass('disabled');

        clearProductFilter();
    });

    function applyProductFilter(form) {
        let pageUrl = $('#page-url').val();
        let params = new URLSearchParams(window.location.search);
        let filter_params = $('#page-filters').val().split(',');

        filter_params.forEach((filter_param) => {
            params.delete(filter_param)  
        });

        params.delete('page');
    
        const formData = new FormData($(form)[0]);

        formData.forEach((value, key) => {
            params.append(key, value);
        });

        let requestURL = `${ pageUrl }?${ params.toString() }`;

        if( [...formData.entries()].length ) $('.clearall--button').removeClass('disabled');
        else $('.clearall--button').addClass('disabled');

        updateProductGrid(requestURL);
    }

    function clearProductFilter() {
        let pageUrl = $('#page-url').val();
        let params = new URLSearchParams(window.location.search);
        let filter_params = $('#page-filters').val().split(',');

        filter_params.forEach((filter_param) => {
            params.delete(filter_param)  
        });

        params.delete('page');

        let requestURL = `${ pageUrl }?${ params.toString() }`;

        updateProductGrid(requestURL);
    }

    function updateProductGrid(requestURL) {
        let sectionId = $('#products-grid-section').val();

        $('.collection--product, .collection--contents .pagination, .products--container .no-products').hide();
        $('.loading-container').css('display', 'flex');

        $('html, body').animate({
            scrollTop: $(`div#shopify-section-${ sectionId } .collection--wrapper`).offset().top - 100
        }, 500);

        // setTimeout(() => {
        $.ajax({
            url: `${ requestURL }&sections=${ sectionId }`,
            type: 'GET',
            ajax: false,
            success: function(data) {
                history.pushState(null, '', requestURL);
                $('body').css('overflow', 'auto');
                $('.collection--wrapper').removeClass('events-disabled');

                // $(`div#shopify-section-${ sectionId }`).html(data[sectionId]);

                // Replacing products html
                let parser = new DOMParser();
                let response = parser.parseFromString(data[sectionId], 'text/html');

                let toolbar = response.querySelector('.collection--toolbar').innerHTML;
                let productsContainer = response.querySelector('.products--container').innerHTML;
                let pagination = response.querySelector('.collection--contents .pagination').innerHTML;
                let count = response.querySelector('.collection--results-count .products--count').innerHTML;
                
                $(`div#shopify-section-${ sectionId } .collection--toolbar`).html(toolbar);
                $(`div#shopify-section-${ sectionId } .products--container`).html(productsContainer);
                $(`div#shopify-section-${ sectionId } .filters-popup--header .products--count`).html(count);
                $(`div#shopify-section-${ sectionId } .collection--contents .pagination`).html(pagination).show();

                // Updating filter options
                let disabled_filters = response.querySelector('#disabled-filters').value.split(',');
                let disabled_selectors = '';
                disabled_filters.forEach((filter, index) => {
                    if( index == 0 ) {
                        disabled_selectors += `.ff--options-item[data-filter-value="${filter}"]`;
                    } else {
                        disabled_selectors += `, .ff--options-item[data-filter-value="${filter}"]`;
                    }
                })
                // console.log('Disabled filters: ', disabled_filters, disabled_selectors);
                $('.ff--options-item').show();
                $(`${disabled_selectors}`).hide();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                $('.collection--product, .collection--contents .pagination, .products--container .no-products').show();
                $('.loading-container').hide();
                console.log("Apply Filter ERROR:", textStatus, errorThrown, jqXHR.responseText);
            }
        });
        // }, 2000);
    }

    // Paginate Scripts
    $(document).on('click', '.collection--contents .pagination a', (e) => {
        e.preventDefault();
        let paginateURL = $(e.target).attr('href');

        updateProductGrid(paginateURL);
    });
    
    // Filter facets accordion
    $(document).on('click', '.filter--facets-wrap .ff--accordion-btn', (evt) => {
        let accordionElem = $(evt.target).closest('.filter--facets-wrap');
        let expanded = $(accordionElem).attr('data-expanded');
    
        if( expanded == 'true' ) {
            $(accordionElem).attr('data-expanded', 'false');
        } else {
            $(accordionElem).attr('data-expanded', 'true');
        }
    });

    // Sidebar Filter Show/Hide
    $(document).on('click', '.collection--filter-toggler', (evt) => {
        let collectionElem = $('.collection--wrapper');
        let expanded = $(collectionElem).attr('data-filter-sidebar');
    
        if( expanded == 'true' ) {
            $('.collection--filter-toggler span').text('Show Filters');
            $(collectionElem).attr('data-filter-sidebar', 'false');
        } else {
            $('.collection--filter-toggler span').text('Hide Filters');
            $(collectionElem).attr('data-filter-sidebar', 'true');
        }
    });

    // Filter checkboxes script
    $(document).on('change', '.ff--option-input', (e) => {
        let value = $(e.target).is(':checked');
        let dataId = $(e.target).attr('data-id');

        $(`input#${ dataId }-mobile`).prop('checked', value);
        $(`input#${ dataId }-desktop`).prop('checked', value);

        $(`#${ dataId }-mobile`).closest('.ff--options-item').attr('data-filter-active', value);
        $(`#${ dataId }-desktop`).closest('.ff--options-item').attr('data-filter-active', value);
    });

    // Open/Close mobile filter
    $(document).on('click', '.mobile--filter-toggler', (e) => {
        $('.filters-popup--container').addClass('active');
        $('body').css('overflow', 'clip');
    });

    $(document).on('click', '.filters-popup--close', (e) => {
        $('.filters-popup--container').removeClass('active');
        $('body').css('overflow', 'auto')
    });

    function checkMobileFilter() {
        if( $(window).width() > 768 ) {
            $('.filters-popup--container').removeClass('active');
            $('body').css('overflow', 'auto');
        }
    }

    checkMobileFilter();

    $(window).resize((e) => {
        checkMobileFilter();
    });
});